export default {"src":"/_next/static/media/401.ef65fcfc.svg","height":405,"width":406,"blurWidth":0,"blurHeight":0};